import axios from './axios.js'
import url from './urls.js'

export default {
  // step 1
  createDemoRequest: (data) => axios.post(url.register_demo_request, data.params),
  verifyOtpSms: (data) => axios.post(url.verify_otp_sms, data.params),

  // step 2
  getSimulatedScenario: () => axios.get(url.simulated_scenario),
  createSimulatedScenario: (data) => axios.post(url.simulated_scenario, data.params),
  createScriptPreview: (data) => axios.post(url.script_preview, data.params),

  // public country-code allow-list (SDD §6.7)
  getEnabledCountryCodes: () => axios.get(url.enabled_country_codes)
}
